export const routeCheckStateSelector = state => state.routeCheck
